export enum CMode {
  /**
   * 正常打印，不旋转
   */
  NORMAL ,
  /**
   * 整个页面顺时针旋转180°后，再打印
   */
  HORIZONTAL,
}
